import AgoraRTC from 'agora-rtc-sdk'

export default (_ctx, inject) => {
  inject('agoraRTC', AgoraRTC)
}
